const anchoredContent = () => {
  const anchorMenu = document.getElementById('js--anchored')

  if (!anchorMenu) return

  const sections = document.querySelectorAll('.anchor')

  let isUserScrolling = false

  if (!sections || !anchorMenu) return

  const handleSmoothScroll = (targetID) => {
    const sectionID = document.getElementById(targetID)

    if (!sectionID) return

    isUserScrolling = true

    const offset = sectionID.getBoundingClientRect().top + window.scrollY

    window.scrollTo(0, offset)

    setTimeout(() => {
      isUserScrolling = false
    }, 1000)
  }

  const handleLinkToggle = (activeTarget) => {
    anchorMenu.querySelectorAll('a').forEach((link) => {
      link.classList.toggle(
        'js--active',
        link.getAttribute('data-target') === activeTarget,
      )
    })
  }

  const handleAnchorEvent = () => {
    anchorMenu.addEventListener('click', (e) => {
      e.preventDefault()

      if (e.target.tagName !== 'A') return

      const newTarget = e.target.getAttribute('data-target')

      handleLinkToggle(newTarget)
      handleSmoothScroll(newTarget)
    })
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (isUserScrolling) return

      const firstVisible = entries.find((entry) => entry.isIntersecting)

      if (!firstVisible) return

      const activeId = firstVisible.target.id

      handleLinkToggle(activeId)
    },

    { rootMargin: '-50% 0px -50% 0px', threshold: 0 },
  )

  sections.forEach((section) => observer.observe(section))

  handleAnchorEvent()
}

export default anchoredContent
